import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AuthUserContainer from '../../containers/AuthUser';
import EnhancedTableHead from '../../components/table/EnhancedTableHead';
import JourneyPlanContainer from '../../containers/JourneyPlan';
import { isFiltered, sortTable, PureRecordRow } from '../../libs/tableUtilities';
import { getGlobalClasses } from '../../themes';
import FilterHeader from '../../components/table/FilterHeader';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
	};
};

const columns = [
	{
		id: 'display',
		label: 'Display',
	},
	{
		id: 'shortDisplay',
		label: 'Short Display',
	},
	{
		id: 'dateCreated',
		label: 'Date Created',
	},
	{
		id: 'actions',
	},
];

function processJourneyPlans(journeyPlans) {
	if (!journeyPlans) {
		return;
	}

	return journeyPlans.map((journeyPlan) => {
		return {
			...journeyPlan,
			dateCreatedFormatted: moment(journeyPlan.dateCreated).format('MMM Do, YYYY'),
		};
	});
}

class JourneyPlans extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'display',
			filter: '',
			formattedRows: processJourneyPlans(props.journeyPlans),
		};

		this.handleFilter = (evt) => this.setState({ filter: evt.target.value });
	}

	componentDidMount() {
		if (!this.props.journeyPlans.length) {
			this.props.searchJourneyPlans();
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.journeyPlans !== this.props.journeyPlans) {
			this.setState({
				formattedRows: processJourneyPlans(this.props.journeyPlans),
			});
		}
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	handleEdit = (journeyPlanId) => {
		this.props.history.push(`/journeyPlan/update/${journeyPlanId}`);
	};

	handleFilter = (event) => {
		this.setState({ filter: event.target.value });
	};

	render() {
		const { classes } = this.props;
		const { filter, order, orderBy, formattedRows } = this.state;

		if (!formattedRows) {
			return <div>Fetching journey plans...</div>;
		}

		const filtered = formattedRows.filter((row) => {
			return !isFiltered({
				filter,
				row,
				fields: ['display', 'shortDisplay'],
			});
		});

		const rows = sortTable({
			rows: filtered,
			order,
			orderBy,
			handleValue: orderBy === 'year' ? _.parseInt : undefined,
		});

		return (
			<Fragment>
				<FilterHeader
					value={filter}
					onChange={this.handleFilter}
					label="Journey Plans"
					buttonText="Add Journey Plan"
					url="/journeyPlan/add"
					canMakeUpdates={true}
				/>

				<Paper className={classes.globalMainPaper}>
					<Table size="small" className={classes.table}>
						<EnhancedTableHead
							columns={columns}
							order={order}
							orderBy={orderBy}
							onRequestSort={this.handleSort}
						/>
						<TableBody>
							{rows.map((row) => {
								return (
									<PureRecordRow hover className={classes.row} key={row.journeyPlanId}>
										<TableCell>{row.display}</TableCell>
										<TableCell>{row.shortDisplay}</TableCell>
										<TableCell>{row.dateCreatedFormatted}</TableCell>
										<TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
											<Button
												className={classes.button}
												onClick={() => this.handleEdit(row.journeyPlanId)}
											>
												Edit
											</Button>
										</TableCell>
									</PureRecordRow>
								);
							})}
						</TableBody>
					</Table>
				</Paper>
			</Fragment>
		);
	}
}

JourneyPlans.propTypes = {
	classes: PropTypes.object.isRequired,

	searchJourneyPlans: PropTypes.func.isRequired,
	journeyPlans: PropTypes.array,

	permissions: PropTypes.array,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates: PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	JourneyPlanContainer,
	AuthUserContainer,
])(JourneyPlans);
